// extracted by mini-css-extract-plugin
export var alt = "SupportTiles-module--alt--4b83c";
export var desktopOnly = "SupportTiles-module--desktopOnly--63698";
export var main = "SupportTiles-module--main--97f21";
export var menuBlock = "SupportTiles-module--menuBlock--b0e37";
export var mobileOnly = "SupportTiles-module--mobileOnly--7bbf5";
export var textLeft = "SupportTiles-module--textLeft--ed7ac";
export var visuallyHidden = "SupportTiles-module--visuallyHidden--2b3fc";